import { render, staticRenderFns } from "./AssignAuthDialog.vue?vue&type=template&id=2707f040&scoped=true"
import script from "./AssignAuthDialog.vue?vue&type=script&lang=js"
export * from "./AssignAuthDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2707f040",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2707f040')) {
      api.createRecord('2707f040', component.options)
    } else {
      api.reload('2707f040', component.options)
    }
    module.hot.accept("./AssignAuthDialog.vue?vue&type=template&id=2707f040&scoped=true", function () {
      api.rerender('2707f040', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/systemManagement/components/AssignAuthDialog.vue"
export default component.exports